import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/workspace/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/workspace/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/workspace/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/workspace/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/workspace/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getFieldsListById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/workspace/${id}/fields/list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const manageFieldsSequence = async (payload, id) => {
  const options = prepareRequestOptions(
    `/admin/workspace/${id}/fields/sequence/manage`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
